var $98fe636f19612bd9$exports = {};
const $98fe636f19612bd9$var$root = document.documentElement;
const $98fe636f19612bd9$var$prefersColorScheme = window.matchMedia("(prefers-color-scheme: dark)");
let $98fe636f19612bd9$var$usingOSPreference = localStorage.getItem("darkMode") === null;
function $98fe636f19612bd9$var$setColorMode(isDark, savePreference = true) {
    $98fe636f19612bd9$var$root.classList.toggle("u-mode-invert", isDark);
    const checkbox = document.getElementById("color-mode");
    if (checkbox) checkbox.checked = isDark;
    if (savePreference) localStorage.setItem("darkMode", isDark ? "true" : "false");
}
function $98fe636f19612bd9$var$initColorMode() {
    const savedMode = localStorage.getItem("darkMode");
    const initialDarkMode = savedMode === null ? $98fe636f19612bd9$var$prefersColorScheme.matches : savedMode === "true";
    $98fe636f19612bd9$var$setColorMode(initialDarkMode, savedMode !== null);
    const checkbox = document.getElementById("color-mode");
    if (checkbox) checkbox.addEventListener("change", ()=>{
        $98fe636f19612bd9$var$usingOSPreference = false;
        $98fe636f19612bd9$var$setColorMode(checkbox.checked, true);
    });
    const toggleLabel = document.querySelector(".toggle-label");
    if (toggleLabel) window.setTimeout(()=>{
        toggleLabel.classList.add("has-transition");
    }, 100);
    $98fe636f19612bd9$var$prefersColorScheme.addEventListener("change", (event)=>{
        if ($98fe636f19612bd9$var$usingOSPreference) $98fe636f19612bd9$var$setColorMode(event.matches, false);
    });
}
function $98fe636f19612bd9$var$initExpandableIntro() {
    const trigger = document.querySelector("[data-more-toggle]");
    if (!trigger) return;
    const targetId = trigger.getAttribute("data-more-toggle");
    const target = targetId ? document.getElementById(targetId) : null;
    const ellipsis = document.querySelector("[data-more-ellipsis]");
    if (!target) return;
    trigger.addEventListener("click", ()=>{
        const willExpand = target.hasAttribute("hidden");
        target.toggleAttribute("hidden");
        trigger.setAttribute("aria-expanded", String(willExpand));
        trigger.textContent = willExpand ? "Less" : "More";
        if (ellipsis) ellipsis.classList.toggle("is-hidden", willExpand);
    });
}
$98fe636f19612bd9$var$initColorMode();
$98fe636f19612bd9$var$initExpandableIntro();


//# sourceMappingURL=repo.4c6903d4.js.map
